import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Button, Collapse } from '@mui/material';
import React, { useState } from 'react';

interface CollapseListProps {
  visibleItems: React.ReactNode;
  collapsedItems?: React.ReactNode[];
  color?: string;
}

const CollapseList = ({ visibleItems, collapsedItems, color }: CollapseListProps) => {
  const [expanded, setExpanded] = useState(false);

  const toggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      {visibleItems}
      {collapsedItems && (
        <>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            {collapsedItems}
          </Collapse>
          {!!collapsedItems?.length && (
            <StyledExpandButton size="small" onClick={toggle} endIcon={<PolarisIcon icon={expanded ? 'up' : 'down'} style={{ color }} />}>
              <span style={{ color }}>{expanded ? 'Collapse' : 'View All'} Tracks</span>
            </StyledExpandButton>
          )}
        </>
      )}
    </div>
  );
};

export default CollapseList;

const StyledExpandButton = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(-1)};
  margin-left: ${({ theme }) => theme.spacing(-1)};
  margin-right: auto;
  display: flex;
  height: 28px;
  padding: 10px;
  svg {
    color: inherit;
    height: 13px;
  }
`;
